module.exports = __webpack_public_path__ + "img/comercial.ff1b2582.png";